<template>
  <BasePopup
    v-model:visible="visible"
    popup-class="lottery-result-popup"
    :mask-closable="true"
    :show-close-btn="true"
    :show-confirm-btn="false"
  >
    <!-- 标题图片 -->
    <div class="lottery-result-title"></div>

    <!-- 奖励列表 -->
    <div class="awards-list">
      <div
        v-for="(award, index) in lotteryAwardList"
        :key="index"
        class="award-item"
      >
        <!-- 奖励图片（带背景） -->
        <div class="award-icon-wrapper">
          <div :class="`award-icon award-icon-${award.icon.replace('.png', '')}`"></div>
        </div>
        <!-- 奖励名称 -->
        <div class="award-name">{{ award.name }}</div>
      </div>
    </div>

    <!-- 确认按钮 -->
    <div class="confirm-btn" @click="closePopup"></div>

    <!-- 提示文字 -->
    <div class="lottery-result-tips">※版本更新後，請返回活動頁領取禮包碼</div>
  </BasePopup>
</template>

<script setup>
import { computed } from 'vue';
import BasePopup from './BasePopup.vue';
import { lotteryAwardList, lotteryResultPopupState } from '@/hooks/useGetAward';

// 弹窗可见性
const visible = computed({
  get: () => lotteryResultPopupState.value,
  set: (val) => lotteryResultPopupState.value = val
});

// 关闭弹窗
const closePopup = () => {
  lotteryResultPopupState.value = false;
};
</script>

